import Table from 'antd/es/table';
import 'antd/lib/table/style';
export default Table;
